/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationRelationDataAccessModeSchema = z.enum(['implicit', 'explicit'])

export type OrganisationRelationDataAccessModeSchema = z.infer<typeof organisationRelationDataAccessModeSchema>
